<template>
  <div class="process-list-page">
    <!-- <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    > -->

    <div v-for="(item, i) in processListFilter" :key="i" class="process-item">
      <div class="process-item__icon">
        <p class="process-item__title">{{ item.title }}</p>
      </div>

      <div class="process-item__btns">
        <b-button
          v-if="isAuditor()"
          variant="outline-success"
          class="btn"
          size="sm"
          @click="handleModelClick(item)"
        >
          <!-- <feather-icon icon="PlusIcon" size="18" /> -->

          <span class="process-item__btns-tip">
            {{ $t('_components.btns.new') }}
          </span>
        </b-button>

        <b-button
          variant="outline-secondary"
          class="btn"
          size="sm"
          @click="pageChange(item)"
        >
          <!-- <feather-icon icon="FileTextIcon" size="18" /> -->

          <span class="process-item__btns-tip">
            {{ $t('_components.btns.view') }}
          </span>
        </b-button>

        <b-button
          v-if="isProcessManager(item)"
          variant="outline-primary"
          class="btn"
          size="sm"
          @click="pageChange(item, true)"
        >
          <!-- <feather-icon icon="EyeIcon" size="18" /> -->

          <span class="process-item__btns-tip">
            {{ $t('_components.btns.all') }}
          </span>
        </b-button>
        <b-button
          v-if="!isAuditor(item)"
          variant="outline-primary"
          class="btn"
          size="sm"
          @click="pageChangeAuditor(item, true)"
        >
          <!-- <feather-icon icon="EyeIcon" size="18" /> -->

          <span class="process-item__btns-tip">
            {{ $t('_components.btns.all') }}
          </span>
        </b-button>
        <!-- v-if="isProcessManager(item) && item.formId === 22" -->

        <b-button
          v-if="isProcessManager(item) && item.formId === 22"
          variant="outline-warning"
          class="btn"
          size="sm"
          @click="sendNotice(item)"
        >
          <span class="process-item__btns-tip">
            {{ $t('_components.btns.send') }}
          </span>
        </b-button>
      </div>
    </div>

    <!-- 提交面试结果或者View页面 -->

    <c-drawer v-model="drawerShow">
      <!-- <template slot="drawerTopBtns">
        <b-button
          variant="primary"
          class="btn-icon ml-1"
          @click="pageChange(website.staffProcessRouter[currentModel.formId])"
        >
          <feather-icon icon="FileTextIcon" />
        </b-button>
      </template> -->

      <template slot="drawerTopTitle">
        <h2 style="transform: translateX(50%) translateY(5px);">
          {{ currentModel.title }}
        </h2>
      </template>

      <add-form
        v-if="drawerShow"
        :form-id="currentModel.formId"
        :process-key="currentModel.processKey"
        :explain="currentModel.explain"
        @close="drawerShow = false"
      />
    </c-drawer>

    <!-- </b-overlay> -->
  </div>
</template>

<script>
import { BButton, BOverlay } from 'bootstrap-vue'
import CDrawer from '@/components/drawer.vue'
import templateFormAPI from '@/api/templateForm/index'
import AddForm from '@/views/apply/components/add.vue'
import website from '@/config/website'
import { mapGetters } from 'vuex'
import todoAPi from '@/api/todo/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vacationOptionAPI from '@/api/staff/vacation/option'
import { getStore, setStore } from '@/util/store'
import { setBufferDictionary } from '@/components/components/utils'
export default {
  components: {
    BButton,
    AddForm,
    CDrawer,
    // BOverlay,
  },
  props: {
    currentObj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      website,
      loading: false,
      drawerShow: false,
      currentModel: {},
      formList: [],
      showHrFormRole: ['hrm', 'hr_manager'],
      showAllViewRole: ['process_manager'],

      NotShowNew: ['Auditor'],
    }
  },
  computed: {
    ...mapGetters(['userAllInfo', 'noticeProcessParams']),
    processListFilter() {
      // const res = []
      // this.processList.forEach(item => {
      //   const params = item
      //   const findData = this.formList.find(x => String(x.formId) === String(item.formId))
      //   if (findData) {
      //     params.processKey = findData.processKey
      //     params.explain = findData.explain
      //     res.push(params)
      //   }
      // })
      const formList = []
      this.formList.forEach((item) => {
        const config = item.configuration ? JSON.parse(item.configuration) : {}
        if (config.type === 1) {
          formList.push(item)
        }
      })
      return formList
    },
    // processList() {
    //   const temp = [
    //     {
    //       icon: 'file-staff',
    //       iconFill: '#FFF',
    //       title: this.i18n('hrForm'),
    //       variant: 'primary',
    //       formId: '18',
    //     },
    //     {
    //       icon: 'file-staff',
    //       iconFill: '#FFF',
    //       title: this.i18n('employment'),
    //       variant: 'primary',
    //       formId: '1',
    //     },
    //     {
    //       icon: 'time',
    //       iconFill: '#FFF',
    //       title: this.i18n('leave'),
    //       variant: 'primary',
    //       formId: '2',
    //     },
    //     // {
    //     //   icon: 'file-staff-one',
    //     //   iconFill: '#FFF',
    //     //   title: '面试审批',
    //     //   variant: 'primary',
    //     //   formId: '4',
    //     // },
    //     // {
    //     //   icon: 'turn-around',
    //     //   iconFill: '#FFF',
    //     //   title: this.i18n('positive'),
    //     //   variant: 'primary',
    //     //   formId: '5',
    //     // },
    //     {
    //       icon: 'right-user',
    //       iconFill: '#FFF',
    //       title: this.i18n('induction'),
    //       variant: 'primary',
    //       formId: '6',
    //     },
    //     {
    //       icon: 'reduce-user',
    //       iconFill: '#FFF',
    //       title: this.i18n('departure'),
    //       variant: 'primary',
    //       formId: '7',
    //     },
    //     // {
    //     //   icon: 'people-delete-one',
    //     //   iconFill: '#FFF',
    //     //   title: this.i18n('fire'),
    //     //   variant: 'primary',
    //     //   formId: '8',
    //     // },
    //     // {
    //     //   icon: 'calendar',
    //     //   iconFill: '#FFF',
    //     //   title: this.i18n('cancelHoliday'),
    //     //   variant: 'primary',
    //     //   formId: '9',
    //     // },
    //     {
    //       icon: 'transform',
    //       iconFill: '#FFF',
    //       title: this.i18n('muddleheaded'),
    //       variant: 'primary',
    //       formId: '10',
    //     },
    //     {
    //       icon: 'take-off',
    //       iconFill: '#FFF',
    //       title: this.i18n('evection'),
    //       variant: 'primary',
    //       formId: '11',
    //     },
    //     // {
    //     //   icon: 'deposit',
    //     //   iconFill: '#FFF',
    //     //   title: this.i18n('reimbursement'),
    //     //   variant: 'primary',
    //     //   formId: '12',
    //     // },
    //     // {
    //     //   icon: 'financing-one',
    //     //   iconFill: '#FFF',
    //     //   title: this.i18n('loan'),
    //     //   variant: 'primary',
    //     //   formId: '13',
    //     // },
    //     // {
    //     //   icon: 'printer-two',
    //     //   iconFill: '#FFF',
    //     //   title: this.i18n('officeEquipment'),
    //     //   variant: 'primary',
    //     //   formId: '14',
    //     // },
    //     {
    //       icon: 'classroom',
    //       iconFill: '#FFF',
    //       title: this.i18n('staffTraining'),
    //       variant: 'primary',
    //       formId: '15',
    //     },
    //     {
    //       icon: 'classroom',
    //       iconFill: '#FFF',
    //       title: this.i18n('trainingFeedback'),
    //       variant: 'primary',
    //       formId: '21',
    //     },
    //     {
    //       icon: 'classroom',
    //       iconFill: '#FFF',
    //       title: this.i18n('employeeSelfAppraisal'),
    //       variant: 'primary',
    //       formId: '22',
    //     },
    //     {
    //       icon: 'classroom',
    //       iconFill: '#FFF',
    //       title: this.i18n('performanceAssessment'),
    //       variant: 'primary',
    //       formId: '23',
    //     },
    //     {
    //       icon: 'classroom',
    //       iconFill: '#FFF',
    //       title: this.i18n('confirmationAssessment'),
    //       variant: 'primary',
    //       formId: '25',
    //     },
    //     {
    //       title: 'Confirmation',
    //       formId: '5',
    //     },
    //   ]
    //   return temp
    // },
  },
  watch: {
    processListFilter: {
      deep: true,
      immediate: true,
      handler(e) {
        if (e.length <= 0) {
          this.$emit('hide')
        } else {
          this.$emit('show')
        }
      },
    },
    noticeProcessParams: {
      handler(val) {
        if (val && val !== {}) {
          this.currentModel = val
          this.drawerShow = true
        }
      },
      deep: true,
    },
    drawerShow(e) {
      this.$emit('drawerShow', e)
    },
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      this.loading = true
      templateFormAPI
        .getList(1, -1, { formType: 2 })
        .then((res) => {
          const temp = res.data.data
          const arr = []
          temp.forEach((item) => {
            const params = item
            params.title = item.baseTemplateForm.formName
            arr.push(params)
          })
          this.formList = arr
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleModelClick(item) {
      console.log(item, item)
      if (Number(item.formId) === 2) {
        vacationOptionAPI.getList(1, -1, { userType: 1 }).then((res) => {
          console.log(res.data, 'res.data')
          const record = res.data.data.records || []
          const list = record.map((item) => {
            return {
              label: item.vacationName,
              value: item.id,
            }
          })
          const lang = getStore({ name: 'language' })
          setBufferDictionary(`vacationInfo-${lang}`, 'dict', {}, list)
          this.currentModel = item
          this.drawerShow = true
        })
      } else {
        this.currentModel = item
        this.drawerShow = true
      }
    },
    pageChange(item, viewAll = false) {
      if (Number(item.formId) === 2) {
        vacationOptionAPI.getList(1, -1, { userType: 1 }).then((res) => {
          console.log(res.data, 'res.data')
          const record = res.data.data.records || []
          const list = record.map((item) => {
            return {
              label: item.vacationName,
              value: item.id,
            }
          })
          const lang = getStore({ name: 'language' })
          setBufferDictionary(`vacationInfo-${lang}`, 'dict', {}, list)
          const query = item
          query.viewAll = viewAll
          const meta = this.$router.currentRoute.meta || {}
          const layout = meta.layout || ''
          this.$router.push({
            path: layout === 'public' ? '/apply/list/public' : '/apply/list',
            query,
          })
        })
      } else {
        const query = item
        query.viewAll = viewAll
        const meta = this.$router.currentRoute.meta || {}
        const layout = meta.layout || ''
        this.$router.push({
          path: layout === 'public' ? '/apply/list/public' : '/apply/list',
          query,
        })
      }
    },
    pageChangeAuditor(item, viewAll = false) {
      const query = item
      query.viewAll = viewAll
      const meta = this.$router.currentRoute.meta || {}
      const layout = meta.layout || ''
      this.$router.push({
        path:
          layout === 'public'
            ? '/apply/listByAuditor/public'
            : '/apply/listByAuditor',
        query,
      })
    },
    // i18n
    i18n(param) {
      return this.$t(`_apply.process.${param}`)
    },
    isAuditor() {
      let hasPermission = true
      this.NotShowNew.forEach((item) => {
        if (this.userAllInfo.roleAlias.indexOf(item) !== -1) {
          hasPermission = false
        }
      })
      return hasPermission
    },
    isProcessManager(row) {
      let hasPermission = false
      if (row.formId === 18) {
        this.showHrFormRole.forEach((item) => {
          if (this.userAllInfo.roleAlias.indexOf(item) !== -1) {
            hasPermission = true
          }
        })
      }
      if (!hasPermission) {
        this.showAllViewRole.forEach((item) => {
          if (this.userAllInfo.roleAlias.indexOf(item) !== -1) {
            hasPermission = true
          }
        })
      }
      if (!hasPermission && row.allUser) {
        if (row.allUser.split(',').indexOf(this.userAllInfo.id) !== -1) {
          hasPermission = true
        }
      }
      return hasPermission
    },
    sendNotice() {
      this.$bvModal
        .msgBoxConfirm(this.$t('_apply.isSend'), {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Continue',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.pageLoading = true
            todoAPi.noticeSend().then((res) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('_default.toast.title'),
                  icon: 'BellIcon',
                  text: this.$t('_default.toast.text.success'),
                  variant: 'success',
                },
              })
            })
          }
          this.pageLoading = false
        })
    },
  },
}
</script>

<style lang="scss">
.process-list-page {
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  .process-item {
    position: relative;
    width: calc((100% - 96px) / 5);

    @media (max-width: 1500px) {
      width: calc((100% - 48px) / 3) !important;
    }
    min-height: 108px;
    border: 1px solid #ddd;
    display: inline-block;
    // padding-top: 1rem;
    // margin: 1rem;
    border-radius: 8px;
    cursor: pointer;

    color: #fff;
    &__icon {
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      height: 50px;
      padding: 0px 16px;
      border-radius: 8px 8px 0px 0px;
      background: var(
        --Linear-Purple,
        linear-gradient(72deg, #6d41ff 3.64%, #2ba2d9 96.85%)
      );
    }
    &__btns {
      position: absolute;
      width: 100%;
      bottom: 0;
      padding: 14px 16px;
      // margin-top: 1rem;
      display: flex;
      justify-content: space-around;
      gap: 16px;
      background: #fff;
      border-radius: 0 0 8px 8px;
      // &-tip {
      //   display: inline-block;
      //   transform: translateY(-2px) translateX(3px);
      // }
      .btn {
        width: 57px;
        flex: 1;
        height: 32px;
        border-radius: 999px;
        padding: 5px 6px;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 157.143% */
        background: #ffffff;
      }
    }
    &__title {
      font-size: 16px;
      text-align: center;
      margin: 0;
      font-weight: 600;
      line-height: 24px;

      // white-space:nowrap;
    }
    &:hover {
      box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
    }
  }
  .apply-induction .my-form {
    height: calc(100% - 140px);
  }
}
</style>
